export { default } from './I18ClientModule';
